import { render, staticRenderFns } from "./deliveryList.vue?vue&type=template&id=5e0494c4"
import script from "./deliveryList.vue?vue&type=script&lang=js"
export * from "./deliveryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports